import { HttpClient } from "@/app/api/HttpClient"
import { API_PREFIX_CONTACT_FORMS_PATH } from "@/constants/prefix-path-api"
import { t } from "@/languages/i18n"
// IMPORT TẤT CẢ INTERFACE TỪ FILE TYPE CHUNG ĐỂ ĐỒNG BỘ
import { message } from "@/lib/config/lib/antd-global"
import { ContactFormPayload, FilterSearchParams } from "@/types/types"

export const fetchContactForms = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      withCount: true,
    },
  }

  // Logic xử lý publicationState cho Tabs
  if (searchTerms.publicationState === "draft") {
    params.publicationState = "preview"
    params.filters.publishedAt = { $null: true } // Lấy những bản nháp
  } else if (searchTerms.publicationState === "live") {
    params.publicationState = "live" // Strapi mặc định chỉ lấy bản đã publish
  } else {
    // Trường hợp "All" (preview)
    params.publicationState = "preview"
  }

  const excludedKeys = [
    "current",
    "pageSize",
    "start",
    "limit",
    "total",
    "page",
    "sort",
    "fields",
    "populate",
    "publicationState",
  ]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "sort") {
      params.sort = value
    } else if (key === "fields") {
      // @ts-ignore
      params.fields = value
    } else if (key === "populate") {
      params.populate = value
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value && key !== "publicationState") {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  // Set default pageSize if not provided
  if (!params.pagination) {
    params.pagination = { withCount: true }
  }
  if (!params.pagination.pageSize) {
    params.pagination.pageSize = "20"
  }

  try {
    const response = await HttpClient.get(`${API_PREFIX_CONTACT_FORMS_PATH}`, { params })
    return {
      data: response.data,
      meta: response.meta,
    }
  } catch (error) {
    message.error(t("Lỗi khi tải danh sách form liên hệ. Vui lòng thử lại."))
    throw error
  }
}

/**
 * LẤY CHI TIẾT MỘT CONTACT FORM THEO ID
 */
export const fetchContactFormId = async (id: number | string) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_CONTACT_FORMS_PATH}/${id}?populate=*`)
    return response.data
  } catch (error) {
    message.error(t("Lỗi khi tải thông tin form liên hệ. Vui lòng thử lại."))
    throw error
  }
}

/**
 * XÓA CONTACT FORM
 */
export const deleteContactForm = async (id: number | string) => {
  try {
    return await HttpClient.delete(`${API_PREFIX_CONTACT_FORMS_PATH}/${id}`)
  } catch (error) {
    message.error(t("Lỗi khi xóa form liên hệ. Vui lòng thử lại."))
    throw error
  }
}

/**
 * CẬP NHẬT THÔNG TIN CONTACT FORM (SỬ DỤNG INTERFACE TỪ TYPE.TS)
 */
export const updateContactForm = async (id: number | string, data: ContactFormPayload) => {
  try {
    return await HttpClient.put(`${API_PREFIX_CONTACT_FORMS_PATH}/${id}`, data)
  } catch (error) {
    message.error(t("Lỗi khi cập nhật form liên hệ. Vui lòng thử lại."))
    throw error
  }
}

/**
 * THÊM MỚI CONTACT FORM (SỬ DỤNG INTERFACE TỪ TYPE.TS)
 */
export const addContactForm = async (data: ContactFormPayload) => {
  try {
    return await HttpClient.post(`${API_PREFIX_CONTACT_FORMS_PATH}`, data)
  } catch (error) {
    message.error(t("Lỗi khi thêm form liên hệ. Vui lòng thử lại."))
    throw error
  }
}
